<template>
  <div>
    <el-popover
      ref='popover'
      placement='left-start'
      width='300'
      trigger='click'>
      <div style='height: 280px;'>
        <el-row>
          <el-col :span='8'>
            <el-button class='optionButton el-icon-sold-out activeColor' @click='optionButtonClick("收入")'></el-button>
            <div class='optionButtonSpan'><span>收入</span></div>
          </el-col>
          <el-col :span='8'>
            <el-button class='optionButton el-icon-sell' :class='buttonDisabled ? "" : "activeColor"' :disabled='buttonDisabled' @click='optionButtonClick("支出")'></el-button>
            <div class='optionButtonSpan'><span>支出</span></div>
          </el-col>
          <el-col :span='8'>
            <el-button class='optionButton el-icon-money' :class='buttonDisabled ? "" : "activeColor"' :disabled='buttonDisabled' @click='optionButtonClick("投资")'></el-button>
            <div class='optionButtonSpan'><span>投资</span></div>
          </el-col>
<!--          <el-col :span='4'>-->
<!--            <el-button class='optionButton el-icon-bank-card'  @click='optionButtonClick("储蓄")'></el-button>-->
<!--            <div class='optionButtonSpan'><span>储蓄</span></div>-->
<!--          </el-col>-->
        </el-row>
        <el-row>
          <el-col :span='8'>
            <el-button class='optionButton el-icon-user' :class='buttonDisabled ? "" : "activeColor"' :disabled='buttonDisabled' @click='optionButtonClick("养老")'></el-button>
            <div class='optionButtonSpan'><span>养老</span></div>
          </el-col>
<!--          <el-col :span='4'>-->
<!--            <el-button class='optionButton el-icon-document'  @click='optionButtonClick("保险")'></el-button>-->
<!--            <div class='optionButtonSpan'><span>保险</span></div>-->
<!--          </el-col>-->
        </el-row>
      </div>
      <el-button v-show='!showButton' style='z-index: 999999;' slot='reference' class="submit"><i class='el-icon-plus' style='display: block; margin: auto;'></i> </el-button>
    </el-popover>
    <income-dialog :dialogVisible.sync='incomeDialogVisible'
                   :params='incomeData'
                   @dialogVisibleChange='handleIncomeDialogChange'
                   @incomeDialogConfirm='handleIncomeDialogConfirm'></income-dialog>
    <expenses-dialog :dialogVisible.sync='expensesDialogVisible'
                     :params='resultParams'
                     @dialogVisibleChange='handleExpensesDialogChange'
                     @dialogConfirm='handleDialogConfirm'></expenses-dialog>
    <invest-dialog :dialogVisible.sync='investDialogVisible'
                   :params='resultParams'
                   @dialogVisibleChange='handleInvestDialogChange'
                   @dialogConfirm='handleDialogConfirm'></invest-dialog>
    <pension-dialog :dialogVisible.sync='pensionDialogVisible'
                    :params='resultParams'
                    :gender='questionData.gender'
                    :retirementAge='retirementAge'
                    @dialogVisibleChange='handlePensionDialogChange'
                    @dialogConfirm='handleDialogConfirm'></pension-dialog>
  </div>
</template>

<script>
import IncomeDialog from './IncomeDialog.vue'
import ExpensesDialog from './ExpensesDialog.vue'
import InvestDialog from './InvestDialog.vue'
import PensionDialog from './PensionDialog.vue'
export default {
  name: 'optionButton',
  components: {IncomeDialog, ExpensesDialog, InvestDialog, PensionDialog},
  props: ['resultParams', 'incomeData', 'showButton', 'questionData', 'retirementAge'],
  data() {
    return {
      popoverVisible: false,
      incomeDialogVisible: false,
      expensesDialogVisible: false,
      investDialogVisible: false,
      pensionDialogVisible: false
    }
  },
  computed: {
    buttonDisabled () {
      return this.incomeData['INCOME_SUBJECT_TO_TAXATION'] === null
    }
  },
  methods: {
    optionButtonClick (type) {
      this.$refs.popover.doClose()
      switch (type) {
        case '收入':
          this.incomeDialogVisible = true
          return
        case '支出':
          this.expensesDialogVisible = true
          return
        case '投资':
          this.investDialogVisible = true
          return
        case '储蓄':

          return
        case '养老':
          this.pensionDialogVisible = true
          return
        case '保险':

          return
        default:
          return
      }
    },
    handleIncomeDialogChange (val) {
      this.incomeDialogVisible = val
      this.$emit('incomeDialogVisibleChange', val)
    },
    handleExpensesDialogChange (val) {
      this.expensesDialogVisible = val
    },
    handleInvestDialogChange (val) {
      this.investDialogVisible = val
    },
    handlePensionDialogChange (val) {
      this.pensionDialogVisible = val
    },
    handleDialogConfirm (index, data) {
      this.$emit('dialogConfirm', index, data)
    },
    handleIncomeDialogConfirm (data) {
      this.$emit('incomeDialogConfirm', data)
    },
  }
}
</script>

<style scoped>
.submit {
  position: fixed;
  bottom: 50px;
  right: 50px;
  background: #b50952;
  border: none;
  color: #fff;
  width: 56px;
  height: 56px;
  font-size: 26px;
  border-radius: 50%;
  text-align: center;
  justify-content: center;
  align-items: center;
  display: flex;
}
.optionButton {
  height: 80px;
  width: 80px;
  margin-top: 20px;
  font-size: 50px;
  text-align: center;
  justify-content: center;
  align-items: center;
  display: flex;
  border: none !important;
}
.activeColor {
  color: #e90a5b;
}
.optionButtonSpan {
  width: 80px;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/options/OptionButton.vue